export default "data:image/gif;base64,R0lGODlhEgAMAPAAAP/XAP8AACH5BAAAAAAALAAAAAASAAwAAAIXhI95we3flEywvomB3SFPbnkSWIkKCRUAOw=="